module.exports = __webpack_public_path__ + "img/greenReadingArt3.e13d4da5.png";